import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

import { LoadingPoolsSpinner } from '../dataConnectMultiPool/LoadingPoolsSpinner';
import { DomainTableItem } from '../types/DomainTableItem';
import { PoolID } from '../types/PoolID';
import { DomainTableBody } from './DomainTableBody';
import { DomainTableHeader } from './DomainTableHeader';

export type DomainTableProps = Readonly<{
    domainItems: ReadonlyArray<DomainTableItem>;
    onEditDomainClicked: (domainId: string) => void;
    onDeleteDomainClicked: (domainId: string, poolId: PoolID) => void;
    hasLoadedEdgePools: boolean;
}>;

export function DomainTable(props: DomainTableProps) {
    const { domainItems, onEditDomainClicked, onDeleteDomainClicked, hasLoadedEdgePools } = props;

    if (!hasLoadedEdgePools) {
      return (
        <table className={tableClass}>
          <DomainTableHeader />
          {LoadingPoolsSpinner()}
        </table>
      );
    }

    if (domainItems.length === 0) {
        return (
            <>
                <table className={tableClass}>
                    <DomainTableHeader />
                </table>
                <div className={noDomainsSpecifiedClass}>{Messages.dataConnectSiteSettingsNoDomainsSpecified()}</div>
            </>
        );
    }

    return (
        <table className={tableClass}>
            <DomainTableHeader />
            <DomainTableBody
                domainItems={domainItems}
                onEditDomainClicked={onEditDomainClicked}
                onDeleteDomainClicked={onDeleteDomainClicked}
            />
        </table>
    );
}

const tableClass = cssClass('domain-table', 'root', {
    width: '100%',
    borderSpacing: 0,
    textAlign: 'left',
    backgroundColor: TabStyles.Colors.White,
    cursor: 'default'
});

const noDomainsSpecifiedClass = cssClass('domain-table', 'no-domains-specified', {
    textAlign: 'center',
    paddingTop: TabStyles.Spacing.DefaultSpace
});
